import { ButtonHTMLAttributes } from 'react';
import { twMerge } from 'tailwind-merge';
import { Color } from '@diritto/common/style/color';
import { ClearIcon } from '@/icons/ClearIcon';

interface ClearButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  size?: number;
  disabled?: boolean;
  className?: string;
  onClick?: () => void;
}

const defaultStyles = 'flex items-center justify-center cursor-pointer';

export const ClearButton = ({ className, onClick, disabled, size = 17, ...props }: ClearButtonProps) => (
  <button
    type="button"
    className={twMerge(defaultStyles, disabled ? 'opacity-30 cursor-not-allowed' : '', className)}
    onClick={disabled ? undefined : onClick}
    {...props}>
    <ClearIcon color={Color.Gray400} size={size} />
  </button>
);
